import style from './index.module.scss';
import { useEditor } from '@smartfire/js-block-engine';

function HeaderButton({ text, link }) {
    const { isEditing } = useEditor();
    return (
        <a className={style.button} href={link && !isEditing && link}>
            {text}
        </a>
    );
}

export default HeaderButton;
